import classNames from 'classnames';
import React, { useState, useRef } from 'react';
import { withNativeProps } from '../../utils/native-props';
import { useInitialized } from '../../utils/use-initialized';
import { mergeProps } from '../../utils/with-default-props';
import Mask from '../mask';
import { useLockScroll } from '../../utils/use-lock-scroll';
import { renderToContainer } from '../../utils/render-to-container';
import { useSpring, animated } from '@react-spring/web';
var classPrefix = "adm-popup";
var defaultProps = {
  position: 'bottom',
  visible: false,
  getContainer: function getContainer() {
    return document.body;
  },
  mask: true
};
export var Popup = function Popup(p) {
  var props = mergeProps(defaultProps, p);
  var bodyCls = classNames(classPrefix + "-body", props.bodyClassName, classPrefix + "-body-position-" + props.position);
  var initialized = useInitialized(props.visible || props.forceRender);
  var ref = useRef(null);
  useLockScroll(ref, props.visible);

  var _useState = useState(props.visible),
      active = _useState[0],
      setActive = _useState[1];

  var _useSpring = useSpring({
    percent: props.visible ? 0 : 100,
    config: {
      precision: 0.1,
      mass: 0.4,
      tension: 300,
      friction: 30
    },
    onStart: function onStart() {
      setActive(true);
    },
    onRest: function onRest() {
      var _a, _b;

      setActive(props.visible);

      if (props.visible) {
        (_a = props.afterShow) === null || _a === void 0 ? void 0 : _a.call(props);
      } else {
        (_b = props.afterClose) === null || _b === void 0 ? void 0 : _b.call(props);
      }
    }
  }),
      percent = _useSpring.percent;

  var node = withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix,
    onClick: props.onClick,
    style: {
      display: active ? 'unset' : 'none'
    }
  }, props.mask && /*#__PURE__*/React.createElement(Mask, {
    visible: props.visible,
    onMaskClick: props.onMaskClick,
    className: props.maskClassName,
    style: props.maskStyle,
    disableBodyScroll: false
  }), /*#__PURE__*/React.createElement(animated.div, {
    className: bodyCls,
    style: Object.assign(Object.assign({}, props.bodyStyle), {
      transform: percent.to(function (v) {
        if (props.position === 'bottom') {
          return "translate(0, " + v + "%)";
        }

        if (props.position === 'top') {
          return "translate(0, -" + v + "%)";
        }

        if (props.position === 'left') {
          return "translate(-" + v + "%, 0)";
        }

        if (props.position === 'right') {
          return "translate(" + v + "%, 0)";
        }

        return 'none';
      })
    }),
    ref: ref
  }, initialized && active && props.children)));
  return renderToContainer(props.getContainer, node);
};